import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UtilityService } from '../../services/utility.service';
import { StorageService } from '../../services';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-error-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-popup.component.html',
  styleUrl: './error-popup.component.scss'
})
export class ErrorPopupComponent implements OnInit, OnDestroy {
  showPopup = false;
  errorMessage = 'Something went wrong';
  errorTitle = 'Error';
  isCloseable = true;
  
  private destroy$ = new Subject<void>();

  constructor(
    private utilityService: UtilityService,
    private router: Router,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    this.utilityService.errorPopup$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.showPopup = state.show;
        if (state.message) {
          this.errorMessage = state.message;
        }
        if (state.title) {
          this.errorTitle = state.title;
        }
        this.isCloseable = state.closeable !== false; // Default to true if not specified
      });
  }

  startNewFlow(): void {
    // Clear session storage
    this.storageService.clearSessionStorage();
    
    // Hide popup
    this.utilityService.hideErrorPopup();
    
    // Navigate to landing page
    this.router.navigate(['/']);
  }

  closePopup(): void {
    // Only allow closing if closeable is true
    if (this.isCloseable) {
      this.utilityService.hideErrorPopup();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
